module.exports = "<span class ='circle' [ngClass]=\"statusClass\" ></span>"